import { render, staticRenderFns } from "./OrderConfirmation-Content.vue?vue&type=template&id=25a6fcc4&"
import script from "./OrderConfirmation-Content.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports